"use client";

import React from "react";
import NextImage from "next/image";

import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

import ImagesCarousel from "../ImagesCarousel";
import styles from "../../styles.module.css";
import "./styles.css";

type Props = {
  images: Array<{
    src: string;
    alt?: string;
    placeholder?: "blur" | "empty";
  }>;
  description?: string;
  fullWidth?: boolean;
  fullHeight?: boolean;
  scaleDown?: boolean;
  row?: boolean;
  sizes?: string;
};
export default function ArticleImages({
  images,
  description,
  fullWidth,
  fullHeight,
  scaleDown,
  row = false,
  sizes,
}: Props) {
  switch (images.length) {
    case 1:
      return (
        <PhotoProvider speed={(type) => 0} photoClosable={true}>
          <figure className={styles.article__image__container}>
            <div
              className={`${styles.article__image__wrapper} ${
                scaleDown ? styles.article__image__wrapper__scale__down : ""
              }`}
            >
              {/* @ts-ignore */}
              <PhotoView src={images[0].src?.src || images[0].src}>
                <NextImage
                  className={`${styles.article__image} ${
                    fullWidth ? styles.article__image__full__width : ""
                  } ${fullHeight ? styles.article__image__full__height : ""} ${
                    scaleDown ? styles.article__image__scale__down : ""
                  }`}
                  src={images[0].src}
                  alt={images[0].alt || ""}
                  fill
                  sizes="100vw"
                  // sizes={
                  //   sizes
                  //     ? sizes
                  //     : "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  // }
                  placeholder={images[0].placeholder}
                />
              </PhotoView>
            </div>
            {description && (
              <figcaption className={styles.article__image__description}>
                {description}
              </figcaption>
            )}
          </figure>
        </PhotoProvider>
      );
    case 2:
      return (
        <PhotoProvider loop speed={(type) => 100} photoClosable={true}>
          <figure className={`${styles.article__image__container}`}>
            <div className={`${styles.article__image__container__two__images} ${row ? '' : styles.article__image__container__two__images__col}`}>
              <div className={styles.article__image__wrapper}>
                {/* @ts-ignore */}
                <PhotoView src={images[0].src?.src || images[0].src}>
                  <NextImage
                    className={`${styles.article__image} ${
                      fullWidth ? styles.article__image__full__width : ""
                    } ${
                      fullHeight ? styles.article__image__full__height : ""
                    } ${scaleDown ? styles.article__image__scale__down : ""}`}
                    src={images[0].src}
                    alt={images[0].alt || ""}
                    fill
                    sizes={row ? "100vw" : "50vw"}
                    // sizes={
                    //   sizes
                    //     ? sizes
                    //     : "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    // }
                    placeholder={images[0].placeholder}
                  />
                </PhotoView>
              </div>
              <div className={styles.article__image__wrapper}>
                {/* @ts-ignore */}
                <PhotoView src={images[1].src?.src || images[1].src}>
                  <NextImage
                    className={`${styles.article__image} ${
                      fullWidth ? styles.article__image__full__width : ""
                    } ${
                      fullHeight ? styles.article__image__full__height : ""
                    } ${scaleDown ? styles.article__image__scale__down : ""}`}
                    src={images[1].src}
                    alt={images[1].alt || ""}
                    fill
                    sizes={row ? "100vw" : "50vw"}
                    // sizes={
                    //   sizes
                    //     ? sizes
                    //     : "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    // }
                    placeholder={images[1].placeholder}
                  />
                </PhotoView>
              </div>
            </div>
            {description && (
              <figcaption className={styles.article__image__description}>
                {description}
              </figcaption>
            )}
          </figure>
        </PhotoProvider>
      );
    default:
      return <ImagesCarousel images={images} />;
  }
}
